import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-game-display',
  templateUrl: './game-display.component.html',
  styleUrls: ['./game-display.component.scss']
})
export class GameDisplayComponent implements OnInit {
  @Input() games: any;
  
  constructor() { }

  ngOnInit(): void {
  }

}
